export function tooltipInit() {
    const selector = '[data-bs-toggle="tooltip"]';
    const triggers = Array.from(document.querySelectorAll(selector));
  
    import('bootstrap/js/dist/tooltip').then(({ default: Tooltip }) => {
      const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  
      triggers.forEach(el => {
        const old = Tooltip.getInstance(el);
        if (old) old.dispose();
  
        new Tooltip(el, {
          trigger: isTouch ? 'click' : 'hover focus',
          container: 'body'
        });
      });
  
      document.addEventListener('show.bs.tooltip', e => {
        triggers.forEach(el => {
          if (el !== e.target) {
            const inst = Tooltip.getInstance(el);
            if (inst) inst.hide();
          }
        });
      });
  
      document.addEventListener('click', e => {
        if (
          !e.target.closest(selector) &&
          !e.target.closest('.tooltip')
        ) {
          triggers.forEach(el => {
            const inst = Tooltip.getInstance(el);
            if (inst) inst.hide();
          });
        }
      });
    });
  }
  